import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";
import React from "react";
import { useTranslate } from "react-admin";

import { DocumentAddButton } from "../AddButton";

export const UploadControls = ({
	disabled,
	uploading,
	isTypeShow,
	isTypeRequired,
	selectedType,
	setSelectedType,
	typeSelectionAttempted,
	setTypeSelectionAttempted,
	currentChoices,
	uploadFile,
}) => {
	const translate = useTranslate();

	return (
		<Grid container spacing={2} alignItems="center">
			{isTypeShow && <Grid item sm={12} md={3}>
				<FormControl fullWidth error={typeSelectionAttempted && !selectedType}>
					<InputLabel id="document-type-select-label">
						{translate("osfc.fields.document.type")}
					</InputLabel>
					<Select
						disabled={disabled}
						labelId="document-type-select-label"
						value={selectedType}
						onChange={(e) => {
							setSelectedType(e.target.value);
							setTypeSelectionAttempted(false);
						}}
					>
						{currentChoices.map((type) => (
							<MenuItem key={type.id} value={type.id}>
								{translate(type.name)}
							</MenuItem>
						))}
					</Select>
					{typeSelectionAttempted && !selectedType && (
						<FormHelperText>{translate("osfc.fields.document.type_is_required")}</FormHelperText>
					)}
				</FormControl>
			</Grid>}
			<Grid item>
				<DocumentAddButton
					disabled={
						disabled || uploading || (isTypeShow && isTypeRequired && typeSelectionAttempted && !selectedType)
					}
					uploading={uploading}
					onBeforeUpload={() => {
						if (isTypeShow && isTypeRequired && !selectedType) {
							setTypeSelectionAttempted(true);
							return false;
						}
						return true;
					}}
					uploadFile={(file) => uploadFile(file, { type: selectedType })}
					acceptTypes={currentChoices.find((t) => t.id === selectedType)?.accept}
				/>
			</Grid>
		</Grid>
	);
};
